import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-claims-msg',
  templateUrl: './claims-msg.component.html',
  styleUrls: ['./claims-msg.component.scss']
})
export class ClaimsMsgComponent implements OnInit {
	
  constructor() { }

  ngOnInit() {
  }
  
  myFormSubmitHandler(){
		let claimsUrl = "https://ebadmin.equitable.com/eb-claims/registration";
		if(window.location.href.indexOf("int-auth") !== -1 )
			claimsUrl = "https://int.ebadmin.equitable.com/eb-claims/registration";
			
		window.location.replace(claimsUrl);
  }

}
